// @ts-ignore
import React from "react";
import { Info } from "react-feather";
import ReactMarkdown from "react-markdown";
import { IconButton } from "@narmi/design_system";

const InfoMessage = ({
  text,
  dismissMessage,
  fromQueryParam = false,
}: {
  text: string;
  dismissMessage: () => void;
  fromQueryParam?: boolean;
}) => (
  <div className="message-content info">
    <Info color="var(--color-warnDark)" />
    <span className="margin--right--l" data-testid="info-message">
      {fromQueryParam ? text : <ReactMarkdown>{text}</ReactMarkdown>}
    </span>
    <IconButton label="Dismiss" kind="plain" name="x" size="xl" onClick={dismissMessage} />
  </div>
);

export default InfoMessage;
